import React from 'react';

type Props = { html?: string; className?: string };

function RawHtml(props: Props) {
  const { html = '', className } = props;
  /* eslint-disable-next-line react/no-danger */
  return <div className={className} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default RawHtml;
